import axios from 'axios'
import type { Summary, SectorsResp, NewsResp, PricingItem, Discovery } from './types'

const API = 'https://fcdx.club/api'

export const getSummary = () => axios.get<Summary>(`${API}/summary`).then(r => r.data)
export const getSectors = () => axios.get<SectorsResp>(`${API}/sectors`).then(r => r.data)
export const getNews = () => axios.get<NewsResp>(`${API}/news`).then(r => r.data)
export const getPricing = () => axios.get<PricingItem[]>(`${API}/pricing`).then(r => r.data)
export const getDiscoveries = () => axios.get<Discovery[]>(`${API}/discoveries`).then(r => r.data)
